import React, {useContext, useState, useEffect} from 'react';
import { Link } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import authServices from '../services/authServices';
import logo from '../images/logo.png';
// import useWebSocket from "../websocket";

const Header = () => {
  // const consumer = useWebSocket();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    checkSignIn()
  }, []);

  // useEffect(() => {
  //   if( consumer ){
  //     const chatSubscription = consumer.subscriptions.create("ChatChannel", {
  //       received: (data) => {
  //         // Recibir datos enviados desde el backend
  //         // setMessages((prev) => [...prev, data.message]);
  //         console.log("Mensaje recibido:", data);
  //       },
  //     });

  //     setSubscription(chatSubscription);

  //     return () => {
  //       chatSubscription.unsubscribe();
  //     };
  //   }
  // }, [consumer]);

  const checkSignIn = async (id) => {
    try {
      const data = await authServices.checkSignIn();

      if(data.token){
        setAuthInformation({
          token: data.token,
          nombre: data.nombre,
          user_id: data.user_id,
          autenticado: true,
          rol: data.rol,
          email: data.email,
          es_empleado_tribunal: data.es_empleado_tribunal
        })
        localStorage.setItem('token', data.token);
      } else {
        setAuthInformation({autenticado: false})
        localStorage.removeItem('token');
      }

    } catch (error) {
      setAuthInformation({autenticado: false})
      localStorage.removeItem('token');
  }
  };

  return (
    <>
      <header className="d-flex flex-wrap align-items-center justify-content-center justify-content-md-between py-3 border-bottom">
        <nav className="navbar">
          <div className="container-fluid">
            <Link
              className="navbar-brand"
              to="/"
              ><img src={logo} className='img-fluid' alt="Bootstrap"/></Link>
            { authInformation.autenticado &&
              `Bienvenid@ ${authInformation.nombre} (${authInformation.rol})`
            }
          </div>
        </nav>

        {/* <pre>{JSON.stringify(googleAuth, null, 2)}</pre> */}
        <div className='container-fluid'>
          <nav className="navbar navbar-expand-lg">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              {(authInformation.autenticado === true && authInformation.rol !== 'Jurado' ) && (
                <li>
                  <div className='dropdown'>
                    <button type="button" data-bs-toggle="dropdown" className="btn btn-primary dropdown-toggle">
                      Concursos
                    </button>
                    <ul className='dropdown-menu'>
                      {(authInformation.rol === 'Admin' || authInformation.rol === 'Veedor' ) && (
                        <>
                        <li><Link className="dropdown-item px-1 py-1" to="/listadoCompletoConcursos">Listado Completo</Link></li>
                        <li><Link className="dropdown-item px-1 py-1" to="/listaOfertas">Listar Concursos</Link></li>
                        {authInformation.rol === 'Admin' && (
                          <li><Link className="dropdown-item px-1 py-1" to="/oferta">Crear Concurso</Link></li>
                        )}
                        <li><hr className='dropdown-divider my-1' /></li>
                        <li><Link className="dropdown-item px-1 py-1" to="/listaMaterialEstudios">Listar Material de Estudio</Link></li>
                        {authInformation.rol === 'Admin' && (
                          <li><Link className="dropdown-item px-1 py-1" to="/material_estudio">Crear Material Estudio</Link></li>
                        )}
                        <li><hr className='dropdown-divider my-1' /></li>
                        <li><Link className="dropdown-item px-2 py-1" to="/listaCargos">Listar Cargos</Link></li>
                        {authInformation.rol === 'Admin' && (
                          <li><Link className="dropdown-item px-2 py-1" to="/cargo">Crear Cargo</Link></li>
                        )}
                        </>
                      )}
                      {(authInformation.rol === 'Registrado' ) && (
                        <li><Link className="dropdown-item px-2" to="/misPostulaciones">Mis postulaciones</Link></li>
                      )}
                    </ul>
                  </div>
                </li>
              )}

              {(authInformation.rol === 'Admin' || authInformation.rol === 'Veedor' || authInformation.rol === 'Jurado' ) && (
                <li>
                  <div className='dropdown'>
                    <button type="button" data-bs-toggle="dropdown" className="btn btn-primary dropdown-toggle">
                      Usuarios
                    </button>
                    <ul className='dropdown-menu'>
                      {
                        (authInformation.rol === 'Admin') && (
                          <>
                            <li><Link className="dropdown-item px-2 py-1" to="/listaUsuarios">Lista de Usuarios</Link></li>
                            <li><Link className="dropdown-item px-2 py-1" to="/usuario">Crear nuevo Usuario</Link></li>
                            <li><Link className="dropdown-item px-2 py-1" to="/emailsPorTipo">Emails por tipo</Link></li>
                          </>
                        )
                      }
                      <li><Link className="dropdown-item px-2 py-1" to="/listaPostulacionesPorOferta">Lista de Postulaciones por Concurso</Link></li>
                      <li><Link className="dropdown-item px-2 py-1" to="/listaPostulaciones">Lista de Postulaciones</Link></li>
                      <li><Link className="dropdown-item px-2 py-1" to="/listaAdmisibles">Listado de Inscriptos</Link></li>
                    </ul>
                  </div>
                </li>
              )}
              <Link rol="button"
              className="px-2 btn btn-outline-secondary"
              to="/ayuda"
              >Ayuda</Link>
            </ul>

            <div className="col-md-4 text-end">
              {
              authInformation.autenticado ?
              <>
              <Link className="btn btn-outline-primary me-2" to="/salir">Salir</Link>
              <div className='dropdown btn btn-outline-light'>
                <button type="button" data-bs-toggle="dropdown" className="btn btn-primary dropdown-toggle">
                  Mi cuenta
                </button>
                <ul className='dropdown-menu'>
                  <li><Link className="dropdown-item" to={`/usuario/${authInformation.user_id}/edit`}>Datos personales</Link></li>
                  <li><Link className="dropdown-item" to="/cambioClave">Cambio de clave</Link></li>
                  {/* <li><Link className="dropdown-item" to="/accesosNginx">Accesos a Nginx</Link></li> */}
                </ul>
              </div>
              </>
              :
              <>
              <Link className="btn btn-outline-primary me-2" to="/ingreso">Entrar</Link>
              <Link className="btn btn-primary" to="/registro">Registrate</Link>
              </>
              }
            </div>

          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;